import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        agents:[],
        securityAlerts:[],
        mitre:[],
        vulnerabilities:[],
        fimActivities:[],
        malwareActivities:[],
    };
  };

const socDataSlice = createSlice({
  name: 'socData',
  initialState:initialState(),
  reducers: {
    setAgents(state, action) {
        state.agents = action.payload;
      },
      setSecurityAlerts(state, action) {
        state.securityAlerts = action.payload;
      },
      setMitre(state, action) {
        state.mitre = action.payload;
      },
      setVulnerabilities(state, action) {
        state.vulnerabilities = action.payload;
      },
      setFIMActivities(state, action) {
        state.fimActivities = action.payload;
      },
      setMalwareActivities(state, action) {
        state.malwareActivities = action.payload;
      },

         
  },
});

export const {
  setAgents,
  setSecurityAlerts,
  setMitre,
  setVulnerabilities,
  setFIMActivities,
  setMalwareActivities,

} = socDataSlice.actions;

export const socData =socDataSlice.reducer;